import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { ProdottiSoftwareService } from 'src/app/core/prodotti-software.service';
import { ProdottoSoftware } from 'src/app/shared/models/prodotto-software.model';

@Component({
  selector: 'app-gestione-prodotti-software',
  templateUrl: './gestione-prodotti-software.component.html',
  styleUrls: ['./gestione-prodotti-software.component.scss']
})
export class GestioneProdottiSoftwareComponent implements OnInit {
  public prodotti$!: Observable<ProdottoSoftware[]>;
  public form: FormGroup;
  public editMode: 'new' | 'edit' | undefined;
  public itemInEdit: ProdottoSoftware | null = null;
  public isDialogOpen = false;

  constructor(
    private readonly prodottiService: ProdottiSoftwareService,
    private readonly fb: FormBuilder,
    private readonly messageService: MessageService
  ) {
    this.form = this.fb.group({
      nomeProdotto: [null, Validators.required],
      versioneProdotto: [null, Validators.required],
      produttore: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.prodotti$ = this.prodottiService.getAll();
  }

  openModal(mode: 'new' | 'edit', item?: ProdottoSoftware): void {
    this.isDialogOpen = true;
    this.editMode = mode;
    this.itemInEdit = item ?? null;
    this.form.patchValue({
      nomeProdotto: item?.nomeProdotto ?? null,
      versioneProdotto: item?.versioneProdotto ?? null,
      produttore: item?.produttore ?? null
    });

    setTimeout(() => {
      document.getElementById('nomeProdotto')?.focus();
    }, 50);
  }

  resetForm(): void {
    this.isDialogOpen = false;
    this.editMode = undefined;
    this.itemInEdit = null;
    this.form.reset();
  }

  saveItem(): void {
    const payload = this.buildPayload(this.itemInEdit ?? undefined);
    if (this.editMode === 'new') {
      this.prodottiService.create(payload).subscribe(
        () => this.handleSuccess('Creazione'),
        err => this.handleError(err)
      );
      return;
    }

    if (this.itemInEdit) {
      this.prodottiService.update(payload).subscribe(
        () => this.handleSuccess('Modifica'),
        err => this.handleError(err)
      );
    }
  }

  removeItem(item: ProdottoSoftware): void {
    this.prodottiService.delete(item).subscribe(
      () => this.handleSuccess('Eliminazione'),
      err => this.handleError(err)
    );
  }

  private handleSuccess(operation: string): void {
    this.message('success', operation, `${operation} Prodotto completato`);
    this.resetForm();
  }

  private handleError(err: Error): void {
    this.message('error', 'Errore', 'Si è verificato un errore. Operazione non completata');
    this.resetForm();
  }

  private message(sev: string, sum: string, det: string): void {
    this.messageService.add({
      key: 'toast',
      severity: sev,
      summary: sum,
      detail: det
    });
  }

  private buildPayload(base?: ProdottoSoftware): ProdottoSoftware {
    const value = this.form.value;
    return {
      ...(base ?? {}),
      nomeProdotto: value.nomeProdotto?.trim(),
      versioneProdotto: value.versioneProdotto?.trim(),
      produttore: value.produttore?.trim()
    } as ProdottoSoftware;
  }
}
